import { useGetQuoteQuery } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { Quote } from "../../types/Quote";
import { getFormattedQuote } from "../../quoteHelpers/quoteHelpers";

const useListQuotes = (id) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data, isLoading, isFetching, refetch } = useGetQuoteQuery({
    slug: accountSlug,
    id,
    include: ["vendor", "lob"],
  });
  let quoteData: Quote | undefined = undefined;
  const vendor = data?.included?.find((item) => item.type === "vendors");
  const lob = data?.included?.find((item) => item.type === "lobs");

  if (data?.data) {
    try {
      quoteData = getFormattedQuote(
        data.data,
        vendor ? [vendor] : [],
        lob ? [lob] : []
      );
    } catch (err) {
      if (err instanceof Error) {
        console.error(err.message);
      } else {
        console.error("An unknown error occurred");
      }
    }
  }

  return {
    quoteData,
    quoteLoading: isLoading,
    quoteFetching: isFetching,
    refetch,
  };
};

export default useListQuotes;
